import { AppDomainConstant } from "../../apis/app-domain.constant";


export class AdministracionNuevoCoreAPIConstant {

  static readonly ADMIN_PRIVILAGE: string="api/v1/privileges";
  static readonly MENUS: string = "/resources";
  static readonly ACTION: string = "/actions";

  static readonly URL_GET_MENUS: string =
    AppDomainConstant.URI_GATEWAY +  this.ADMIN_PRIVILAGE+
    this.MENUS;

  static readonly URL_GET_SELECT_ITEMS: string =
    AppDomainConstant.URI_GATEWAY +  this.ADMIN_PRIVILAGE+
    this.ACTION;

  static readonly URL_GET_SELECT_ITEMS_PARENTS: string =
    AppDomainConstant.URI_GATEWAY +  this.ADMIN_PRIVILAGE+
    this.MENUS +
    "/parents";

  static readonly URL_CREAR_MENU: string =
    AppDomainConstant.URI_GATEWAY + this.ADMIN_PRIVILAGE+
    this.MENUS;

  static readonly URL_EDITAR_MENU: string =
    AppDomainConstant.URI_GATEWAY +  this.ADMIN_PRIVILAGE+
    this.MENUS;
}
